
import { useState } from "react";
import { CellPosition } from "../types/workout-types";

interface NavigationState {
  currentWeekIndex: number;
  setCurrentWeekIndex: (index: number) => void;
  currentDayIndex: number;
  setCurrentDayIndex: (index: number) => void;
  activeCell: CellPosition | null;
  setActiveCell: (cell: CellPosition | null) => void;
  editMode: boolean;
  setEditMode: (mode: boolean) => void;
  tempValue: string;
  setTempValue: (value: string) => void;
  forceRender: number;
  setForceRender: (value: number | ((prevValue: number) => number)) => void;
}

export function useWorkoutNavigationState(): NavigationState {
  const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const [activeCell, setActiveCell] = useState<CellPosition | null>(null);
  const [editMode, setEditMode] = useState(false);
  const [tempValue, setTempValue] = useState("");
  const [forceRender, setForceRender] = useState(0);

  return {
    currentWeekIndex,
    setCurrentWeekIndex,
    currentDayIndex,
    setCurrentDayIndex,
    activeCell,
    setActiveCell,
    editMode,
    setEditMode,
    tempValue,
    setTempValue,
    forceRender,
    setForceRender
  };
}
